import { Navigate, Outlet } from "react-router-dom";

function Auth({ user, location }) {
  if (user && !location?.state?.gotoJobBoard) {
    return <Navigate to={user.phoneNumber ? '/dashboard' : '/my-profile'} replace />;
  } else {
    return <Outlet />;
  }
}
export default Auth;
